import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider, useContent } from "@/context/ContentContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Stats from "@/components/Stats";
import Solutions from "@/components/Solutions";
import Projects from "@/components/Projects";
import Subsidiaries from "@/components/Subsidiaries";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Announcements from "@/components/Announcements";

function ScrollToHash() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const tryScroll = (attempts) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempts > 0) {
          setTimeout(() => tryScroll(attempts - 1), 100);
        }
      };
      setTimeout(() => tryScroll(10), 100);
    }
  }, [location]);
  return null;
}

function HomePage() {
  const { loading, content } = useContent();
  if (loading || !content) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#F9F8F6] text-[#1A3626]"
        data-testid="content-loading"
      >
        <div className="font-serif text-xl tracking-wide">Loading…</div>
      </div>
    );
  }
  return (
    <div className="App bg-[#F9F8F6]">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Stats />
        <Solutions />
        <Projects />
        <Subsidiaries />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function AnnouncementsPage() {
  return (
    <div className="App bg-[#F9F8F6]">
      <Navbar />
      <main>
        <Announcements />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <ScrollToHash />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/announcements" element={<AnnouncementsPage />} />
          </Routes>
          <Toaster position="bottom-right" richColors closeButton />
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}
